import { type ReactNode } from 'react';

// Smooth expand/collapse without JS height measurement. Uses the
// `grid-template-rows: 0fr <-> 1fr` trick: a one-row grid whose row
// height transitions, with the inner child set to overflow:hidden +
// min-h-0 so the row can really collapse to zero. Works in every
// evergreen browser and respects prefers-reduced-motion.
//
// Children stay mounted regardless of `open`, which keeps any local
// state (lazy-fetched data, scroll position, focus) intact across
// toggles.

interface CollapsibleProps {
  open: boolean;
  children: ReactNode;
  id?: string;
}

export function Collapsible({ open, children, id }: CollapsibleProps): JSX.Element {
  return (
    <div
      id={id}
      className={`grid transition-[grid-template-rows] duration-200 ease-out motion-reduce:transition-none ${
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      }`}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden">{children}</div>
    </div>
  );
}
